function slider() {
  [...document.querySelectorAll('.slider-wrapper-scale .splide')]?.forEach(slider => {
    let splideInstance;
    const wrapper = slider.closest('.slider-wrapper-scale');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;
    const desktopAutoplay = (wrapper.dataset.desktopAutoplay ?? 'true') !== 'false';

    const initSlider = () => {
      const windowWidth = window.innerWidth;
      const type = windowWidth < 1024 ? 'fade' : 'slide';

      // Clean up any previous instance and classes before re-init (e.g., on resize)
      if (splideInstance) {
        splideInstance.destroy();
      }
      // Ensure we start with a clean state for classes
      const allSlides = slider.querySelectorAll('.splide__slide');
      allSlides.forEach((el) => {
        el.classList.remove('fade-out');
        el.classList.remove('fade-in');
      });

      const defaultOptions = {
        type: type,
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        easing: 'linear',
        start: 0,
        breakpoints: {
          1024: {
            gap: 0,
            start: 1,
            width: '49.375rem',
            autoWidth: false,
            focus: 'center',
            pagination: false,
            autoplay: desktopAutoplay,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          }
        },
      }

      splideInstance = new Splide(slider, defaultOptions );

      // Helper to apply fade-out only to the slide immediately before the active one
      const applyPrevFadeOut = (activeIndex) => {
        const slides = slider.querySelectorAll('.splide__slide');
        const len = slides.length;
        const prevIdx = (activeIndex - 1 + len) % len;
        slides.forEach((el, idx) => {
          if (idx === prevIdx) {
            el.classList.add('fade-out');
          } else {
            el.classList.remove('fade-out');
          }
          // Clear any previous fade-in while we prepare a clean state
          el.classList.remove('fade-in');
        });
      };

      // Helper to apply fade-in only to the slide immediately after the active one
      const applyNextFadeIn = (activeIndex) => {
        const slides = slider.querySelectorAll('.splide__slide');
        const len = slides.length;
        const nextIdx = (activeIndex + 1) % len;
        slides.forEach((el, idx) => {
          if (idx === nextIdx) {
            el.classList.add('fade-in');
          } else {
            el.classList.remove('fade-in');
          }
        });
      };

      // On initial mount, set the fade-out on the slide before the active one
      // and fade-in on the slide after the active one
      splideInstance.on('mounted', () => {
        const currentIndex = splideInstance.index;
        applyPrevFadeOut(currentIndex);
        applyNextFadeIn(currentIndex);
      });

      // Update on every move: use prevIndex/newIndex from Splide
      splideInstance.on('move', function (newIndex, prevIndex /*, destIndex */) {
        // The slide we are leaving (prevIndex) should be the one that fades out,
        // and others should not have fade-out.
        const slides = slider.querySelectorAll('.splide__slide');
        const len = slides.length;
        const nextIdx = (newIndex + 1) % len;
        slides.forEach((el, idx) => {
          // Handle fade-out for the slide we leave
          if (idx === prevIndex) {
            el.classList.add('fade-out');
          } else if (idx === newIndex) {
            // The new active slide should not be faded out
            el.classList.remove('fade-out');
          } else {
            // Clear from all other slides to keep only the immediate previous marked
            el.classList.remove('fade-out');
          }

          // Handle fade-in for the slide immediately after the new active slide
          if (idx === nextIdx) {
            el.classList.add('fade-in');
          } else {
            el.classList.remove('fade-in');
          }
        });
      });

      splideInstance.mount();
    };
    
    initSlider();
    window.addEventListener('resize', initSlider);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  slider();
});
